import "./Support.scss";
import { useEffect, useState } from "react";
import BlueButton from "../../components/BlueButton/BlueButton";
import EditUser from "./../../assets/edit-user.svg";
import DeleteUser from "./../../assets/delete.svg";
import AddGif from "./../../assets/add-gif.gif";
import { TextField, useMediaQuery } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import MessageModals from "../../components/MessageModals/MessageModals";
import SwipeableModals from "./SwipeableModals/SwipeableModals";
import api from "../../utils/api";

import { QuestionColumns } from "../../SourceData";
import SwitchButton from "../../components/SwitchButton/SwitchButton";
import { message } from "antd";

const SupportQuestion = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [query, setQuery] = useState("");

  const [currentModalView, setCurrentModalView] = useState("changePassword");
  const [openDelete, setOpenDelete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (query.length >= 2 || query.length === 0) {
        getData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, page, pageSize]);

  const getData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page + 1,
        limit: pageSize,
        type: "shops",
      });

      if (query.length >= 2) {
        params.append("search", query);
      }

      const res = await api.get(`/support_questions?${params.toString()}`);
      setData(res.data.data);
      setTotalRows(res?.data?.total || 0);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  const handleActive = async (row) => {
    setLoading(true);
    try {
      await api.put(`/support_questions/${row.id}`, {
        active: row.active === true ? false : true,
      });
      getData();
      message.success("تم تعديل الحالة بنجاح");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (row) => {
    setSelectedQuestion(row);
    setCurrentModalView("editQuestion");
    setIsOpen(true);
  };

  const actionColumn = [
    {
      field: "active",
      headerName: "الحالة",
      minWidth: 80,
      headerAlign: "right",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        const isActive = params?.row?.active === true;
        return (
          <SwitchButton
            checked={isActive}
            onClick={() => handleActive(params.row)}
          />
        );
      },
    },
    {
      field: "action",
      headerName: "",
      width: 160,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            <div className="cell-btn" onClick={() => handleEdit(params.row)}>
              <img src={EditUser} alt="" />
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                setOpenDelete(true);
                setSelectedQuestion(params.row);
              }}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="support">
      <div className="support-header">
        <div className="actions-container">
          <div className="search">
            <TextField
              id="outlined-search"
              type="search"
              value={query}
              placeholder="ابحث..."
              onChange={(e) => setQuery(e.target.value)}
              sx={{
                width: isMobile ? "100%" : "380px",
                borderRadius: "8px",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <BlueButton
            text="اضافة سؤال جديد"
            size={isMobile ? "full" : isTablet ? "fit" : "large"}
            variant="fill"
            onClick={() => handleOpen("createQuestion")}
            icon={<img src={AddGif} alt="" />}
          />
        </div>
      </div>

      <div className="container">
        <DataGrid
          sx={{ backgroundColor: "white", width: "100%" }}
          autoHeight={true}
          columns={QuestionColumns.concat(actionColumn)}
          rows={data.map((row, index) => ({
            ...row,
            index: page * pageSize + index + 1,
          }))}
          disableVirtualization
          disableColumnFilter
          disableColumnMenu
          loading={loading}
          paginationMode="server"
          rowCount={totalRows}
          pageSizeOptions={[10, 25, 50]}
          paginationModel={{
            page,
            pageSize,
          }}
          onPaginationModelChange={handlePaginationModelChange}
        />
      </div>

      <MessageModals
        open={openDelete}
        onClose={() => {
          setOpenDelete(false);
          setSelectedQuestion(null);
        }}
        currentView="delete"
        route={`/support_questions/${selectedQuestion?.id}`}
        onDataChange={getData}
        text="تم حذف السؤال بنجاح"
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
        refreshData={getData}
        initialData={selectedQuestion} // You'll need to track the selected question for editing
      />
    </div>
  );
};

export default SupportQuestion;
